import { inheritsLoose as _inheritsLoose, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import React, { Component } from 'react';
import { interpolate } from 'd3-interpolate';

/**
 * Interpolates changes and applies them to children over time
 */
var PropInterpolatorWrapper = function PropInterpolatorWrapper(WrappedComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(PropInterpolator, _Component);
    function PropInterpolator() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.state = {
        interpolationFn: null,
        progress: 0,
        startTime: 0
      };
      return _this;
    }
    var _proto = PropInterpolator.prototype;
    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
      // TODO allow passing custom interpolators to support changing the
      // term of a loan (array length) in line chart
      var interpolationFn = (nextProps.customInterpolator || interpolate)(_omit(this.props, this.props.excludeFromInterpolation), _omit(nextProps, nextProps.excludeFromInterpolation));
      this.setState({
        interpolationFn: interpolationFn,
        progress: 0,
        startTime: new Date().getTime()
      });
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this2 = this;
      if (!global.window.requestAnimationFrame) {
        // eslint-disable-next-line zillow/react/no-did-update-set-state
        this.setState({
          progress: 1
        });
      }
      global.window.requestAnimationFrame(function () {
        if (_this2.state.progress < 1) {
          var time = new Date().getTime();
          var completion = (time - _this2.state.startTime) / _this2.props.transitionDuration;
          if (completion >= 1) {
            completion = 1;
          }
          _this2.setState({
            progress: _this2.props.easingFn(completion)
          });
        }
      });
    };
    _proto.render = function render() {
      var excludedProps = _pick(this.props, this.props.excludeFromInterpolation);
      var props = this.props;
      if (this.state.interpolationFn && this.state.progress < 1) {
        props = this.state.interpolationFn(this.state.progress);
      }
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, excludedProps));
    };
    return PropInterpolator;
  }(Component), _class.defaultProps = {
    excludeFromInterpolation: [],
    transitionDuration: 300,
    easingFn: function easingFn(t) {
      return t;
    } // linear
  }, _class;
};
var PropInterpolatorWrapper$1 = PropInterpolatorWrapper;

export { PropInterpolatorWrapper$1 as default };
